
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import LandingPageContent from '@/components/landing/LandingPageContent';

const Index: React.FC = () => {
  return (
    <div id="top" className="min-h-screen flex flex-col">
      <Navbar />
      <LandingPageContent />
      <Footer />
    </div>
  );
};

export default Index;
